import { createNames } from "../../utils";
export const getAceHeaderNames = (id) => {
    return createNames(id, 'ACE-HEADER', 'NAVBAR', 'NAVIGATION', 'LOGO_WRAPPER', 'LOGO', 'MENU', 'RIGHT_MENU', 'ACTIONS_WRAPPER', 'ACTIONS_WRAPPER____ICONS', 'ACTIONS_WRAPPER____CTAS', 'HELP_BUTTON', 'DEPOSIT_BUTTON', 'REGISTER_BUTTON', 'LOGIN_BUTTON', 'PROFILE_BUTTON', 'SEARCH_BUTTON', 'HIDDEN_ON_SEARCH_OPEN', 'SUBMENU', 'NOTIFICATIONS', 'OFFCANVAS_MENU_BUTTON', 'OFFCANVAS_MENU', 'OFFCANVAS_MENU____SHOW', 'SEARCH', 'SEARCH____WITHIN_SUBMENU', 'SEARCH____WITHIN_NAVIGATION', 'SEARCH_RESULTS', 'SEARCH_RESULTS____VISIBLE');
};
export const aceHeaderParts = {
    NAVBAR: 'ace-header-navbar',
    SUBMENU: 'ace-header-submenu',
    LOGO_WRAPPER: 'ace-header-logo-wrapper',
    LOGO: 'ace-header-logo',
    REGISTER_BUTTON: 'ace-header-register-button',
    SEARCH_BUTTON: 'ace-header-search-button',
    SEARCH_BUTTON_TOGGLED: 'ace-header-search-button-toggled',
    DEPOSIT_BUTTON: 'ace-header-deposit-button',
    OFFCANVAS_MENU_BUTTON: 'ace-header-offcanvas-menu-button',
    ACTIONS_WRAPPER_ICONS: 'ace-header-actions-wrapper-icons',
    ACTIONS_WRAPPER_CTAS: 'ace-header-actions-wrapper-ctas',
    SEARCH_WITHIN_SUBMENU: 'ace-header-search-within-submenu',
};
//# sourceMappingURL=ace-header.get-names.js.map
